module.exports = __webpack_public_path__ + "482b0b173ff6f8c9b4959dbc61166f81.svg";